/** @format */

import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Chain, Environment } from '@shared/data-access/interfaces';
import { UtilityService, WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'common-paypal-pay-later',
	templateUrl: './paypal-pay-later.component.html',
	styleUrl: './paypal-pay-later.component.scss',
	imports: [CommonModule]
})
export class PaypalPayLaterComponent implements OnInit {
	@Input() price: number;
	@Input() paypalPayLaterEnabled: boolean;
	@Input() page: string; // for supported values see https://developer.paypal.com/docs/business/checkout/pay-later-messaging/customize/customize-the-messaging/#page-type

	constructor(
		@Inject(WINDOW) protected window: Window,
		public environment: Environment,
		private chain: Chain,
		private utilityService: UtilityService
	) {}

	ngOnInit() {
		if (this.paypalPayLaterEnabled) {
			this.enablePaypal();
		}
	}

	private enablePaypal() {
		const { baseUrl, clientIdParam, additionalParams } =
			this.environment.thirdParty.paypal.store[this.chain.chainIdentifierAbbr];

		/* istanbul ignore else */
		if (baseUrl && clientIdParam && additionalParams) {
			const script = `${baseUrl}${clientIdParam}${additionalParams}`;
			this.utilityService.loadExternalScript(script);
		}
	}
}
